import { render, staticRenderFns } from "./LoadingBackground.vue?vue&type=template&id=2b3edd77&"
import script from "./LoadingBackground.vue?vue&type=script&lang=js&"
export * from "./LoadingBackground.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports